module.exports = __webpack_public_path__ + "img/bitcoin.b17af6ec.jpg";